<template>
  <v-dialog v-model="dialog" persistent max-width="1000px" content-class="configuration-dialog" :fullscreen="$vuetify.breakpoint.smAndDown">
    <template v-slot:activator="{ on }">
      <v-btn depressed color="primary" v-on="on">
        <v-icon left>search</v-icon>View Details
      </v-btn>
    </template>
    <template v-if="dialog">
      <v-flex>
        <v-card flat dark>
          <v-toolbar dark color="primary">
            <v-toolbar-title>View Configuration</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="close()" dark>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card>
      </v-flex>
      <v-flex style="overflow: auto;">
        <v-card v-if="showLabel" flat dark>
          <v-card-text>
            <v-layout class="mb-4" wrap>
              <v-chip color="white" :text-color="textColor" style="margin: 0 auto; margin-top: 15px;">
                <v-avatar>
                  <v-icon class="default">{{ labelIcon }}</v-icon>
                </v-avatar>
                {{ labelMessage }}
              </v-chip>
            </v-layout>
            <v-layout wrap>
              <span style="text-align: left;">{{ additionalMessage }}</span>
            </v-layout>
          </v-card-text>
          <TreeViewComponent v-if="!!executeResponse" :data="{ value: executeResponse }" />
        </v-card>
        <v-card>
          <v-card-text pa-0>
            <Show :configuration="configuration" />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card style="border-top: 1px solid #dddddd;">
          <v-card-actions>
            <ConfirmationDialog @submit="remove" :disabled="isExecuting" label="Delete" title="Delete configuration" text="Are you sure you want to remove this configuration?" />
            <v-spacer></v-spacer>
            <v-btn :loading="isExecuting" @click="execute()" color="warning" style="margin: 0 auto;">
              <v-icon left>play_circle_outline</v-icon>Execute Once
            </v-btn>
            <EditDialog :disabled="isExecuting" v-if="dialog" :form="form" :configuration="configuration" @fetchConfigurations="fetchConfigurations"/>
            <v-btn color="secondary" outline @click="close()">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </template>
  </v-dialog>
</template>

<script>
  import ErrorMessages from '../Helpers/ErrorMessages'
  import Show from './Show'
  import EditDialog from './EditDialog'
  import ConfirmationDialog from '../Helpers/ConfirmationDialog'

  export default {
    components: {
      Show,
      EditDialog,
      ConfirmationDialog,
    },
    props: {
      configuration: Object,
      form: Function,
    },
    data: () => ({
      dialog: false,
      showLabel: false,
      labelIcon: 'close',
      labelColor: 'warning',
      textColor: 'white',
      labelMessage: '',
      additionalMessage: '',
      isExecuting: false,
      executeResponse: null,
    }),
    computed: {
      currentService() {
        return this.$store.getters['serviceconfigurations/currentService']
      },
    },
    methods: {
      fetchConfigurations() {
        console.log('edit completed')
        this.$emit('fetchConfigurations')
        this.close()
      },
      close() {
        this.dialog = false
      },
      async remove() {
        try {
          await this.$store.dispatch('serviceconfigurations/deleteConfiguration', {
            service: this.currentService,
            configuration: this.configuration,
          })

          this.$emit('fetchConfigurations')
          this.close()
        } catch (error) {
          console.error(error)
          this.showLabel = true
          this.labelMessage = ErrorMessages.fatalErrorMessageLabel
          this.additionalMessage = ErrorMessages.fatalErrorMessageLong
          this.labelIcon = 'close'
          this.labelColor = 'warning'
        }
      },
      setLabel(showLabel, labelIcon, labelColor, textColor, labelMessage, additionalMessage) {
        this.showLabel = showLabel
        this.labelIcon = labelIcon
        this.labelColor = labelColor
        this.textColor = textColor
        this.labelMessage = labelMessage
        this.additionalMessage = additionalMessage
      },
      async execute() {
        this.setLabel(true, 'done', 'default', 'black', 'Please wait, this may take a while', '')
        this.isExecuting = true

        try {
          let response = await this.$store.dispatch('serviceconfigurations/executeImport', {
            service: this.currentService,
            configuration: this.configuration,
            // Implement if you need it:
            /* payload: 
            {
              data: object 
            }
            */
          })

          if (response.IsError) {
            this.setLabel(true, 'error', 'default', 'black', 'Executed with errors',
              'Results:')
          } else {
            this.setLabel(true, 'done', 'default', 'black', 'Executed successfully',
              'Results:')
          }
          this.executeResponse = response

        } catch (error) {
          this.setLabel(true, 'error', 'default', 'black', 'Failed to execute',
            'Something went wrong:')
          this.executeResponse = error
        }

        this.isExecuting = false
      },
    },
  }
</script>

<style scoped>
  .v-dialog--fullscreen>.v-card {
    min-height: 85px !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card {
    min-height: Calc(100% - 85px) !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card .v-card__text {
    padding: 0px !important;
  }
</style>
<style>
  .configuration-dialog {
    display: flex;
    flex-direction: column;
  }
</style>
